import React from 'react';
import Title from '../../partials/title';
import { Animated } from 'react-animated-css';

// August 6th: refactored for responsiveness
const Who = () => {
    return (
        <div className="w3-container w3-content pt-8 pb-8">
            <Title text="Who" className="black" />
            <div className="d-flex row-column margin-top">
                <Animated animationIn="fadeInLeft" className="w-100 bg-whiteish d-flex flex-column w3-card" style={{ padding: 50 }}>
                    <span className="font-20 black hind align-self-center">YOUTH DIVISIONS</span>
                    <span className="font-12 gray hind align-self-center text-center">BOYS/GIRLS teams U6 through U18</span>
                </Animated>
                <div style={{ width: 30, height: 5 }} />
                <Animated animationIn="fadeInLeft" className="w-100 bg-whiteish d-flex flex-column w3-card" style={{ padding: 50 }}>
                    <span className="font-20 black hind align-self-center">ADULT DIVISIONS</span>
                    <span className="font-12 gray hind align-self-center text-center">MEN and WOMEN (OPEN, COED, OVER 30, OVER 40)</span>
                </Animated>
            </div>
            <div className="p-4 bg-red margin-top justify-content-center d-flex flex-row">
                <span className="white">There will be 2 divisions (1st and 2nd division) for U9 through Adult, where there are enought entries to support them</span>
            </div>
        </div>
    );
}

export default Who;



// WEBPACK FOOTER //
// ./src/components/information/partials/who.js